<template>
    <div id="app">
        <v-app id="inspire">
            <v-navigation-drawer class="white" app permanent width="250">
                <v-container>
                <v-toolbar flat class="white">
                    <v-list>
                    <v-list-tile>
                        <v-list-tile-title class="title font-weight-bold">
                        Service Scheduler
                        </v-list-tile-title>
                    </v-list-tile>
                    </v-list>
                </v-toolbar>
                </v-container>

                <v-container>
                <v-list>
                    <v-list-tile v-for="item in items" :key="item.title" @click="goToPage(item.url)">
                    <v-list-tile-action>
                        <v-icon :color="item.color">{{ item.icon }}</v-icon>
                    </v-list-tile-action>
            
                    <v-list-tile-content class="body-1 font-weight-regular">
                        <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                    </v-list-tile-content>
                    </v-list-tile>
                </v-list>
                <v-divider></v-divider>
                </v-container>
            </v-navigation-drawer>

            <v-content>
                <v-layout>
                    <v-flex>
                        <router-view/>
                    </v-flex>
                </v-layout>
            </v-content>
        </v-app>
    </div>
</template>

<script>
import firebase from "firebase";
import firebaseui from "firebaseui";
import "../../node_modules/firebaseui/dist/firebaseui.css";
import { config } from "../firebaseConfig";
import router from '../router';
import { db } from '../main.js'
import { mapGetters, mapActions } from "vuex";
import store from '../stores'
import moment from 'moment'
import _ from 'lodash';
export default {
    data() {
        return {
            items: [
                { title: 'Dashboard', icon: 'timeline', color:"blue", url:"dashboard" },
                // { title: 'Website', icon: 'web', color:"deep-orange", url:"website-management"},
                { title: 'Request Appointments', icon: 'inbox', color:"deep-orange", url:"service-approval"},
                { title: 'Events', icon: 'event', color:"deep-orange", url:"branch-event"},
                { title: 'Branches', icon: 'domain', color:"amber accent-4", url:"branch-maintenance" },
                { title: 'Master List', icon: 'settings', color:"indigo", url:"service-management"},
                { title: 'Service Menu', icon: 'menu', color:"teal accent-4", url:"service-menu"},
                { title: 'Users', icon: 'people', color:"blue-grey", url:"users-management"},
                { title: 'Reports', icon: 'analytics', color:"blue", url:"reports"},
                { title: 'Log-out', icon: 'exit_to_app', color:"pink", url:"logout"}
            ],
            item: 1,
        }
    },

    methods: {
        goToPage(page) {
            this.$router.push("/"+page)
        },
    },

    computed : {
        ...mapGetters(["user"]),
    },
}
</script>

<style scoped>

</style>




